import {Action} from 'redux'
import {actionTypes} from './constants'

export interface ActionWithPayload<T> extends Action {
  payload?: T
}

export interface ICreditCardApplicationReportState {
  data?: {
    data?: any[]
    meta?: any
  }
  loading?: boolean
}

const initialState: ICreditCardApplicationReportState = {
  data: {data: [], meta: {}},
  loading: false,
}

export const reducer = (
  state: ICreditCardApplicationReportState = initialState,
  action: ActionWithPayload<ICreditCardApplicationReportState>
) => {
  switch (action.type) {
    case actionTypes.GET_CREDIT_CARD_APPLICATION_REPORT_START:
      return {...state, loading: true}
    case actionTypes.GET_CREDIT_CARD_APPLICATION_REPORT_SUCCESS:
      return {...state, data: action.payload, loading: false}
    case actionTypes.GET_CREDIT_CARD_APPLICATION_REPORT_FINISH:
      return {...state, loading: false}
    default:
      return state
  }
}
